import React, { FC } from 'react';
import './field.sass';

type AppFiledBoxProps = {
    label: string;
    labelTop?: boolean
    requere?: boolean;
    className?: string;
    styles?: React.CSSProperties
    children?: React.ReactNode;
}

const hasRequer = (children: any): boolean => {
  let requiredRule = false;

  if(children) {
    if(children.type && children.type.name === 'RequiredRule') {
      requiredRule = true;
    } else {
      return hasRequer(children.props?.children);
    }
  }


  return requiredRule;
};


const AppFiledBox: FC<AppFiledBoxProps> = (props) => {
  const isRequer = hasRequer(props.children) || props.requere;

  return (
    <div
      className={`dx-fieldset  ${props.labelTop ? 'field-box' : ''}` + props.className || ''}
      style={props.styles}
    >
      <div className={`dx-field ${props.labelTop ? 'field-box__block' : ''}`}>
        <div className={`dx-field-label ${props.labelTop ? 'field-box__label' : ''}`}>
          { props.label } { isRequer && '*'}
        </div>
        <div className={`dx-field-value  ${props.labelTop ? 'field-box__input' : ''}`}>
          { props.children }
        </div>
      </div>
    </div>
  );
};

export default AppFiledBox;

